// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"3abff638","484":"14cb0921","851":"3f0086ba"}[chunkId] + ".chunk.js";
};